<div style="width: 100%">
  <div class="header">
    <div class="navigation">
      <app-breadcrumb />
    </div>

    <app-risk-score-diagram />
  </div>
  <div class="row">
    <div class="titles-container">
      <h1
        [class.title]="currentView !== 'complianceElement'"
        [class.subtitle]="currentView === 'complianceElement'"
      >
        {{ title }}
      </h1>
      <h2 class="title" *ngIf="currentView === 'complianceElement'">
        {{ complianceElement.name | desanitize }}
      </h2>
      <p *ngIf="currentView === 'riskFlag'" class="flag-description">
        Visualize the top HCP data for this risk activity across regions and
        markets.
      </p>
    </div>

    <div class="action-buttons">
      <button
        class="primary"
        [matMenuTriggerFor]="menu"
        aria-label="Open actions menu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button class="secondary" (click)="openFilterDialog()">
          <mat-icon>filter_alt</mat-icon>
          Filter
        </button>
        <button class="secondary" (click)="openDateRangePicker()">
          <mat-icon>calendar_month</mat-icon>
          Date Range
        </button>
        <button
          class="secondary"
          (click)="openCompareDialog()"
          *ngIf="displayCompareButton"
        >
          <mat-icon>compare_arrows</mat-icon>Compare To
        </button>
        <button class="secondary" *ngIf="false">
          <mat-icon>download</mat-icon>Download
        </button>
        <button class="secondary" *ngIf="false">
          <mat-icon>dashboard_customize</mat-icon>Custom
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="row">
    <!-- filter visualizer -->
    <app-filter-visualizer (filterCleared)="reloadData()" />
  </div>
  <div class="info-card" *ngIf="currentView !== 'riskFlag'">
    <div *ngIf="data" class="overview-card">
      <div class="card-header">Overview</div>
      <div class="card-body row">
        <div class="flags">
          <div class="overview-score">
            <span class="flag-title"> Risk activity count </span>
            <span class="indicator" *ngIf="false"></span>
            {{ isLoading ? "Loading..." : (flagCount | numberAbbreviate) }}
          </div>
          <div class="flag-count">
            <span class="flag-title"> Risk % </span>
            <span class="flag-list">
              <span class="flag-item">
                <span class="flag-square red"> </span>
                <span class="visual-percent"> {{ percentageSum.high }}% </span>
              </span>
              <span class="flag-item">
                <span class="flag-square yellow"> </span>
                <span class="visual-percent">
                  {{ percentageSum.medium }}%
                </span>
              </span>
              <span class="flag-item">
                <span class="flag-square green"> </span>
                <span class="visual-percent"> {{ percentageSum.low }}% </span>
              </span>
            </span>
          </div>
        </div>
        <div class="summary">
          <div class="summary-title">Executive summary</div>
          {{
            currentView === "complianceElement"
              ? complianceElement.exec_summ
              : data.therapeuticArea.description
          }}
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading">Loading compliance data...</div>
  <ng-container *ngIf="!isLoading && data">
    <app-ta-overview *ngIf="currentView === 'therapeuticArea'" [data]="data" />
    <app-compliance-element-detail
      *ngIf="currentView === 'complianceElement'"
      [data]="data"
      [elementName]="complianceElement.name"
      [percentageSum]="percentageSum"
    />
    <app-risk-flag-detail *ngIf="currentView === 'riskFlag'" />
  </ng-container>
</div>
